import React from 'react';
export function Footer() {
  return <footer className="bg-brand-dark text-slate-400 py-8 md:py-12 border-t border-slate-800" data-id="element-74">
      <div className="max-w-6xl mx-auto px-3 sm:px-6 lg:px-8" data-id="element-75">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8 mb-6 md:mb-8 pb-6 md:pb-8 border-b border-slate-800" data-id="element-76">
          <div data-id="element-77">
            <div className="flex items-center mb-3 md:mb-4" data-id="element-78">
              <div className="w-8 h-8 md:w-10 md:h-10 bg-brand-accent rounded-lg flex items-center justify-center text-brand-dark font-bold text-base md:text-xl mr-2 md:mr-3" data-id="element-79">
                RF
              </div>
              <span className="text-white font-bold text-lg md:text-xl tracking-tight" data-id="element-80">
                Recursos Fitness
              </span>
            </div>
            <p className="text-xs md:text-sm mb-3 md:mb-4 max-w-sm" data-id="element-81">
              Accedé a nuestro catálogo completo. Planificaciones, guías,
              material didáctico y mucho más.
            </p>
            <a href="https://www.recursosfitness.shop" target="_blank" rel="noopener noreferrer" className="text-brand-accent hover:text-brand-accentHover text-xs md:text-sm font-medium transition-colors" data-id="element-82">
              Ver catálogo →
            </a>
          </div>

          <div className="md:text-right" data-id="element-83">
            <h4 className="text-white font-serif font-bold text-base md:text-lg mb-2 md:mb-4" data-id="element-84">
              PATINAJE ARTÍSTICO RESUELTO™
            </h4>
            <p className="text-xs md:text-sm mb-3 md:mb-4 md:ml-auto max-w-sm" data-id="element-85">
              El sistema de clases N°1 para profesores de patinaje artístico en
              Argentina. Porque enseñar patinaje no debería costarte todas las
              noches de la semana.
            </p>
            <div className="space-y-1 md:space-y-2 text-xs md:text-sm" data-id="element-86">
              <p data-id="element-87">contacto@recursosfitness.shop</p>
              <p data-id="element-88">@recursosfitness.ar</p>
              <p data-id="element-89">recursosfitness.shop</p>
            </div>
          </div>
        </div>

        <div className="text-center text-[10px] md:text-xs text-slate-500" data-id="element-90">
          <p data-id="element-91">© RecursosFitness™ 2026 — Todos los derechos reservados.</p>
        </div>
      </div>
    </footer>;
}